//
//
//
//
//
//
//
//
//

import TaskDetailsItem from '@/components/tasks/TaskDetailsItem'
import { UsersIcon } from 'vue-feather-icons'

export default {
  name: 'TaskDetailsApplications',
  components: {
    TaskDetailsItem,
    UsersIcon
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    count () {
      return this.$store.getters['tasks/getTaskApplicationsCount'](this.task?.id)
    }
  }
}
